// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-1_ZE7";
var _4 = "block-yPsCY";
var _5 = "block__body-360wm";
var _6 = "block__body__header-27KeE";
var _7 = "block__footer-2EnNC";
var _8 = "block__title-2LAG8";
var _9 = "block__title_highlighted-16_2R";
var _a = "block__sub-14hnb";
var _b = "block__sub_highlighted-3xf8g";
var _c = "bags-2BDqC";
var _d = "bag-O5sOi";
var _e = "bag__count-2uiBQ";
var _f = "fareFamilyName-15mzi";
var _10 = "price-2nGvx";
var _11 = "price_withIncluded-1UmP0";
var _12 = "block__button-30d2S";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "block", _5 as "block__body", _6 as "block__body__header", _7 as "block__footer", _8 as "block__title", _9 as "block__title_highlighted", _a as "block__sub", _b as "block__sub_highlighted", _c as "bags", _d as "bag", _e as "bag__count", _f as "fareFamilyName", _10 as "price", _11 as "price_withIncluded", _12 as "block__button" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "block": _4, "block__body": _5, "block__body__header": _6, "block__footer": _7, "block__title": _8, "block__title_highlighted": _9, "block__sub": _a, "block__sub_highlighted": _b, "bags": _c, "bag": _d, "bag__count": _e, "fareFamilyName": _f, "price": _10, "price_withIncluded": _11, "block__button": _12 }
